module.exports = __webpack_public_path__ + "img/LogoSimple.a1b14f82.png";